// extracted by mini-css-extract-plugin
export var locationCard = "_px-0";